<div class="catalog-info">
  <div class="catalog-info__main">
    <div class="article-count">
      <span class="article-count__value">{{ catalogData().articleTotalCount ?? 0 | number }}</span>
      <span>Artikel {{ articleHasPictures() ? ', davon ' : '' }}</span
      >&nbsp;
      @if (articleHasPictures()) {
        <span class="article-count__value">{{ catalogData().articleWithPicturesCount ?? 0 | number }}</span>
        <span>mit Bildern</span>
      }
    </div>

    @if (catalogHasValidCovinRate()) {
      <mp-catalog-covin-badge class="catalog-covin-badge" [value]="catalogData().covinRate" />
    }
  </div>

  @if (showAdditionalInfo()) {
    <div class="catalog-info__additional">
      <div class="catalog-tasks-info">
        @for (taskInfo of catalogData().openTasks | keyvalue: orginalSorting; track taskInfo) {
          @if (taskInfo.value) {
            <mp-task-info [icon]="getTaskInfoIcon(taskInfo.key)" [openTask]="taskInfo.value" />
          }
        }
      </div>

      <div class="catalog-actions">
        <ng-content select="[catalog-card-footer-actions]" />

        <button mat-stroked-button class="catalog-actions__details-button" (click)="navigateToDetails()">
          <span>Details</span>
        </button>
      </div>
    </div>
  }
</div>
